<template>
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">
    <!-- FLORES DECORATIVAS -->
    <img src="@/assets/flor1.png" class="flor flor-1" alt="" />
    <img src="@/assets/flor4.png" class="flor flor-2" alt="" />
    <img src="@/assets/flor3.png" class="flor flor-3" alt="" />

    <!-- BOLA DISCO GIRANDO -->
    <img src="@/assets/disco.png" class="bola bola-izquierda" alt="" />

    <!-- IMAGEN CON RECORTE -->
    <div class="imagen-xv-wrapper">
      <img src="@/assets/ai_.webp" class="imagen-xv" alt="Foto protagonista" />
    </div>

    <!-- TEXTO PRINCIPAL -->
    <section class="texto-xv">
      <p class="frase-bendicion">
        Con la bendición de Dios <br />
        y de mis padres
      </p>

      <div class="separador-elegante" aria-hidden="true"></div>

      <h1 class="nombre-protagonista">Leonardo&nbsp; Morgan</h1>
      <h1 class="nombre-protagonista">Alejandra&nbsp; Lopez</h1>

      <p class="parrafo-presentacion">
        Hay momentos que definen nuestra vida, quedando grabados en el alma y la memoria.
        Hoy experimento uno de esos instantes especiales y quiero compartirlo con quienes
        tienen un lugar en mi corazón.
      </p>
    </section>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      // Helper seguro: convierte selectores a nodos y filtra nulos
      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      const foto = $('.imagen-xv-wrapper')
      const flores = ['.flor-1', '.flor-2', '.flor-3'].flatMap($)
      const texto = [
        '.frase-bendicion',
        '.separador-elegante',
        '.nombre-protagonista',
        '.parrafo-presentacion'
      ].flatMap($)

      // Estado inicial (evita parpadeo)
      gsap.set([...foto, ...flores, ...texto], { autoAlpha: 0, y: 28 })
      gsap.set(flores[0], { rotate: -8, scale: 0.95 })
      gsap.set(flores[1], { rotate: -18, scale: 0.94 })
      gsap.set(flores[2], { rotate: -12, scale: 0.94 })

      // Observa viewport y anima 1 sola vez
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          // 1) IMAGEN primero (reveal luxury: zoom + blur suave)
          tl.fromTo(
            foto,
            { scale: 0.94, y: 40, filter: 'blur(6px)' },
            { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 1.15 }
          )

          // 2) FLORES (entrada escalonada) + loop sutil de "float"
          tl.to(
            flores,
            { autoAlpha: 1, y: 0, rotate: (i) => [-2, -6, -4][i] || -4, duration: 0.9, stagger: 0.12 },
            '-=0.55'
          )

          // 3) TEXTO en cascada
          tl.to(texto, { autoAlpha: 1, y: 0, duration: 0.8, stagger: 0.15 }, '-=0.25')

          // Micro-loops para sensación viva
          if (flores[0]) gsap.to(flores[0], { y: '-=10', duration: 2.2, yoyo: true, repeat: -1, ease: 'sine.inOut' })
          if (flores[1]) gsap.to(flores[1], { y: '+=12', x: '-=4', duration: 2.6, yoyo: true, repeat: -1, ease: 'sine.inOut', delay: 0.2 })
          if (flores[2]) gsap.to(flores[2], { y: '-=8', duration: 2.0, yoyo: true, repeat: -1, ease: 'sine.inOut', delay: 0.1 })
          gsap.to(foto, { scale: 1.01, duration: 3.2, yoyo: true, repeat: -1, ease: 'sine.inOut' })

          io.disconnect() // solo una vez
        })
      }, { threshold: 0.45 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>

<style scoped>
.portada-xv{
  position:relative;
  width:100%;
  min-height:100vh;
  background:#fff;
  overflow:visible;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  padding:48px 16px 56px;
}

/* Marco con recorte superior redondeado (look luxury) */
.imagen-xv-wrapper{
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 6px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background:#fff;
  box-shadow:
    0 12px 40px rgba(0,0,0,.18),
    0 2px 8px rgba(0,0,0,.06);
  will-change: transform, filter, opacity;
}
.imagen-xv{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
}

/* Texto */
.texto-xv{
  max-width: 620px;
  text-align:center;
  margin-top: 22px;
  padding: 0 8px;
}
.frase-bendicion{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color:#2f2e2e;
  line-height:1.5;
  margin: 20px 0 10px;
}
.separador-elegante{
  width:110px;
  height:2px;
  margin:12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}
.nombre-protagonista{
  font-family: "titulos", cursive;
  font-size: 52px;
  color:#e6b1c4;
  margin: 0 0 8px 0;
  line-height:1.1;
}
.parrafo-presentacion{
  font-family: "quote", sans-serif;
  font-size: clamp(14px, 2.6vw, 16px);
  color:#3d3c3c;
  line-height:1.7;
  margin-top: 6px;
}

/* FLORES */
.flor{
  position:absolute;
  width:min(44vw, 240px);
  z-index:10;
  transform-origin:center;
  will-change: transform, opacity;
}
.flor-1{ top:-10px; left:-110px; z-index:5; }
.flor-2{ top:60px; right:-80px; transform: rotate(-80deg); z-index:1; width:min(60vw, 340px); }
.flor-3{ bottom:-50px; left:-120px; transform: rotate(-30deg); z-index:9;}

/* BOLA DISCO */
.bola{
  position:absolute;
  width:120px;
  animation: girar 10s linear infinite;
  opacity:.85;
  z-index:1;
  will-change: transform;
}
.bola-izquierda{ left:-20px; bottom:-50px; z-index:9;}
@keyframes girar{ from{transform:rotate(0)} to{transform:rotate(360deg)} }

/* Responsive refinado */
@media (min-width: 992px){
  .portada-xv{ padding-top:64px; }
  .imagen-xv-wrapper{ margin-top: 0; }
}
</style>
